import { DateTime } from 'luxon';
import { MIN_SUPPORTED_DATE } from 'utils/date-time';

export enum TabsName {
  MyInsight = 'myInsight',
  Supervisor = 'supervisor'
}

export const hasValidStartDate = (startDate: string): boolean => {
  const sDate = DateTime.fromISO(startDate);
  if (sDate < MIN_SUPPORTED_DATE) {
    return false;
  } else return true;
};
